import http from "@/request"


/**
 * 获取单位列表
 * @param {*} param 
 * @returns 
 */
export function listUnit(data) {
    return http({
        url: "/baseUnit/list",
        method: "post",
        data: data
    });
}


/**
 * 保存单位
 * @param {*} data 
 * @returns 
 */
export function saveUnit(data) {
    return http({
        url: "/baseUnit/saveInfo",
        method: "post",
        data: data
    });
}


/**
 * 删除单位
 * @param {*} data 
 * @returns 
 */
export function deleteById(data) {
    return http({
        url: "/baseUnit/deleteById",
        method: "post",
        data: data
    });
}



/**
 * 根据编码查询单位
 * @param {*} code 
 * @returns 
 */
export function getBaseInfoByCode(code) {
    return http({
        url: "/baseUnit/getBaseInfoByCode/" + code,
        method: "get"
    });
}


// WEBPACK FOOTER //
// ./src/api/unit.js